import { useContext } from 'react';

import AccountingContext from './context';

const useAccounting = () => useContext(AccountingContext);

export default useAccounting;
